module.exports = __webpack_public_path__ + "static/media/test_removeHeaderEndings.46141994.csv";